import { action } from "@storybook/addon-actions";
import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import React from "react";
import Radio from "./Radio";

type Story = GenericStory<React.ComponentProps<typeof Radio>>;

const commonArgs: React.ComponentProps<typeof Radio> = {
    checked: false,
    onChange: action("onChange"),
    trackName: "Stories.Radio.TrackEvent",
    size: "sm",
    disabled: false
};

export default {
    title: "Form Components/Radio",
    component: Radio,
    args: commonArgs,
    argTypes: { size: { control: "radio", options: ["sm", "md"] } }
} as ComponentMeta<typeof Radio>;

const Template: Story = ({ checked: checkedProp, onChange, ...args }) => {
    const [checked, setChecked] = React.useState(checkedProp);

    React.useEffect(() => {
        setChecked(checkedProp);
    }, [checkedProp]);

    const handleChange = (value: boolean) => {
        setChecked(value);
        onChange?.(value);
    };

    return <Radio checked={checked} onChange={handleChange} {...args} />;
};

export const Default = Template.bind({});

export const WithLabel = Template.bind({});
WithLabel.args = {
    label: "Radio Label",
    helperText: "Radio helper text"
};

export const Medium = Template.bind({});
Medium.args = {
    label: "Radio Label",
    helperText: "Radio helper text",
    size: "md"
};

export const Disabled = Template.bind({});
Disabled.args = {
    disabled: true
};

export const DisabledChecked = Template.bind({});
DisabledChecked.args = {
    disabled: true,
    checked: true
};
